var _effectorFileName = "/src/shared/api/auth/login/api.ts";
import { withFactory as _withFactory } from "effector";
import { createMutation } from '@farfetched/core';
import { createEffect, createEvent, createStore } from 'effector';
import { login } from '@/shared/api/generated/auth/auth';
import { LoginDto } from '@/shared/api/generated/model';
export const $token = createStore<string | null>(null, {
  loc: {
    file: _effectorFileName,
    line: 7,
    column: 22
  },
  name: "$token",
  sid: "byfu3h"
});
export const setToken = createEvent({
  loc: {
    file: _effectorFileName,
    line: 9,
    column: 24
  },
  name: "setToken",
  sid: "-4p8m11"
});

/**
 * Login
 */
export const postLoginFx = createEffect(async (loginData: LoginDto) => {
  const loginResponse = await login(loginData);
  return loginResponse;
}, {
  loc: {
    file: _effectorFileName,
    line: 14,
    column: 27
  },
  name: "postLoginFx",
  sid: "-8szqgg"
});
export const postLoginDataMutation = _withFactory({
  sid: "m578ph",
  fn: () => createMutation({
    handler: postLoginFx
  }),
  name: "postLoginDataMutation",
  method: "createMutation",
  loc: {
    file: _effectorFileName,
    line: 20,
    column: 37
  }
});